export default __webpack_public_path__ + "static/media/Done.d4b86560.gif";